import React from 'react';
import {LinesContext, UserContext, WorkflowsContext} from '@web/hooks/context';
import WorkflowMain from './WorkflowMain';
// import ActionData from './ActionData';
import {Card, List, Tag} from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import useDocumentFirestore from '@web/hooks/useDocumentFirestore';
import aiActions from '@web/redux/ai/actions';
import Action from './Action';
import {safeJson} from '@web/lib/firestore.db';
import PropTypes from 'prop-types';
import collectionActions from '@web/redux/collections/actions';
import Loading from '@web/components/Loading';
// import {contentTypes} from '@oven/app-thescribe/src/dashboard.config';

const converter = {
  toFirestore: (data) => {
    // const serializedData = {...data};
    // Object.keys(serializedData).forEach(key => {
    //   if (serializedData[key] instanceof Date) {
    //     serializedData[key] = serializedData[key].toISOString();
    //   }
    // });
    // return serializedData;
    return data;
  },
  fromFirestore: (snapshot) => safeJson(snapshot.data()),
};

WorkflowEditor.propTypes = {
  workflowId: PropTypes.string,
};

function WorkflowEditor(props) {
  const dispatch = useDispatch();
  const helpersId = 'workflow-helpers';
  const [, h] = React.useContext(UserContext);
  const ctx = React.useContext(LinesContext);
  // const dataPath = [h, ctx.collectionId].join("/");
  const helpers = useSelector((state) => state.Collections[helpersId]?.table);
  const [workflow] = useDocumentFirestore([ctx.basePath, props.workflowId].join('/'), converter);
  const [activeServiceView, setActiveServiceView] = React.useState('agent');
  // const defaultActions = [
  //   'saveSessionResult', 'throwError',
  // ];
  // console.log("WorkflowEditor:props:", props.workflowId, workflow);
  /**
   * @constant action
   * @type {models.Action.Data[]}
   */
  const actions = [
    {
      type: 'human',
      method: 'user:text',
      description: 'Get text input from the user',
      agentId: 'ai-workflow-human-action-manager',
      icon: 'TbUserEdit',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a {{service.method.split(":")[1]}} input helper is to obtain the specified {{service.method.replace(":", " ")}} for use later in the service following provided instructions.',
        // 'You are a helper for a multi-step service. Your role as a helper is to help collect user input to be used later in the service. You follow provided instructions to collect user input and save it when finished.',
        '<Action>',
        '<Goal>Collect the specified {{service.method.replace(":", " ")}} and save it.</Goal>',
        `<Type>{{service.type}}</Type>`,
        `<Method>{{service.method}}</Method>`,
        `<Description>{{service.description}}</Description>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Your role is strictly scoped to collecting and saving user input. Anything additional is out of scope and strictly forbidden unless providing information to assist the user in responding.<Example>If your instructions indicated you are to collect the user\'s writing preference, providing the user with tips to improve their writing would be out of scope and damaging to the overall service. Assisting the user in articulating their writing style would be acceptable.</Example></OutOfScope>',
        '<SuccessCriteria>You\'re successful when you efficiently collect the requested user input and execute the saveSessionResult tool without performing any other actions</SuccessCriteria>',
        '</Action>',
      ].join("/n"),
      actionNames: [
        'useSearchAgent',
        'useInternetAgent',
        'useNotesAgent',
        'useRemindersAgent',
        'useCalendarAgent',
        'usePhoneCallAgent',
        'useVoiceChatAgent',
        ...defaultActions,
      ],
      tip: 'The agent will ask the user for text input when the app runs this step',
    },
    {
      type: 'human',
      method: 'user:file',
      description: 'Get a file from the user',
      agentId: 'ai-workflow-human-action-manager',
      icon: 'TbUserUp',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a {{service.method.split(":")[1]}} input helper is to obtain the specified {{service.method.replace(":", " ")}} for use later in the service following provided instructions.',
        // 'You are a helper for a multi-step service. Your role as a {{service.method?.split(":")[1]}} helper is to obtain the specified {{service.method.replace(":", " ")}} for use later in the service following any provided instructions.',
        '<Action>',
        '<Goal>Collect specified user input and save it.</Goal>',
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Your role is strictly scoped to collecting and saving user input. Anything additional is out of scope and strictly forbidden unless providing information to assist the user in responding.<Example>If your instructions indicated you are to collect the user\'s writing preference, providing the user with tips to improve their writing would be out of scope and damaging to the overall service. Assisting the user in articulating their writing style would be acceptable.</Example></OutOfScope>',
        '<SuccessCriteria>You\'re successful when you perform the requested task and execute the saveSessionResult tool without performing any other actions</SuccessCriteria>',
        '</Action>',
      ].join('\n'),
      actionNames: [
        'useUploadsAgent',
        'useSearchAgent',
        'useInternetAgent',
        'useNotesAgent',
        'useRemindersAgent',
        'useCalendarAgent',
        'usePhoneCallAgent',
        'useVoiceChatAgent',
        ...defaultActions,
      ],
      tip: 'The agent will ask the user to upload a file when the app runs this step',
    },
    {
      type: 'human',
      method: 'user:auth',
      description: 'Get authorization from the user',
      agentId: 'ai-workflow-human-action-manager',
      icon: 'TbUserCheck',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a {{service.method.split(":")[1]}} input helper is to obtain the specified {{service.method.replace(":", " ")}} for use later in the service following provided instructions.',
        // 'You are a helper for a multi-step service. Your role as a auth helper is to get authorization from the user to be used later in the service. You follow provided instructions to collect user input and save it when finished.',
        '<Action>',
        '<Goal>Collect the specified {{service.method.replace(":", " ")}} and save it.</Goal>',
        // '<Goal>Perform the specified authentication task for the user input and securely save any credentials.</Goal>',
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Your role is strictly scoped to collecting and saving user input. Anything additional is out of scope and strictly forbidden unless providing information to assist the user in responding.<Example>If your instructions indicated you are to collect the user\'s writing preference, providing the user with tips to improve their writing would be out of scope and damaging to the overall service. Assisting the user in articulating their writing style would be acceptable.</Example></OutOfScope>',
        '<SuccessCriteria>You\'re successful when you perform the requested task and execute the saveSessionResult tool without performing any other actions</SuccessCriteria>',
        '</Action>',
      ].join('\n'),
      actionNames: [
        'useUploadsAgent',
        'useSearchAgent',
        'useInternetAgent',
        'useNotesAgent',
        'useRemindersAgent',
        'useCalendarAgent',
        'usePhoneCallAgent',
        'useVoiceChatAgent',
        ...defaultActions,
      ],
      tip: 'The agent will ask the user for authorization when the app runs this step',
      validators: [
        'Instructions must clearly describe the authentication expected from the user',
      ],
    },
    {
      type: 'human',
      method: 'user:approval',
      description: 'Get approval from the user',
      agentId: 'ai-workflow-human-action-manager',
      icon: 'TbUserHeart',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a {{service.method.split(":")[1]}} input helper is to obtain the specified {{service.method.replace(":", " ")}} for use later in the service following provided instructions.',
        // 'You are a helper for a multi-step service. Your role as a helper is to help collect user input to be used later in the service. You follow provided instructions to collect user input and save it when finished.',
        '<Action>',
        '<Goal>Collect the specified {{service.method.replace(":", " ")}} and save it.</Goal>',
        // '<Goal>Collect specified user input and save it.</Goal>',
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Your role is strictly scoped to collecting and saving user input. Anything additional is out of scope and strictly forbidden unless providing information to assist the user in responding.<Example>If your instructions indicated you are to collect the user\'s writing preference, providing the user with tips to improve their writing would be out of scope and damaging to the overall service. Assisting the user in articulating their writing style would be acceptable.</Example></OutOfScope>',
        '<SuccessCriteria>You\'re successful when you efficiently collect the requested user input and execute the saveSessionResult tool without performing any other actions</SuccessCriteria>',
        '</Action>',
      ].join('\n'),
      actionNames: [
        'useUploadsAgent',
        'useSearchAgent',
        'useInternetAgent',
        'useNotesAgent',
        'useRemindersAgent',
        'useCalendarAgent',
        'usePhoneCallAgent',
        'useVoiceChatAgent',
        ...defaultActions,
      ],
      tip: 'The agent will ask the user for approval when the app runs this step',
      validators: [
        'Instructions must clearly describe the approval expected from the user',
        'Instructions must clearly describe disapproval actions',
      ],
    },
    {
      type: 'value',
      method: 'value:constant',
      description: 'Provides a constant value',
      agentId: 'ai-workflow-value-action-manager',
      icon: 'TodoIcon',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a {{service.method.split(":")[1]}} value helper is to return the specified {{service.method.replace(":", " ")}} for use later in the service following provided instructions.',
        `<Service>`,
        `<Goal>Provide the constant value</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        `</Service>`,
      ].join('\n'),
      actionNames: [
        ...defaultActions,
      ],
      tip: 'Provide the constant value',
      validators: [
        'Instructions must include the constant value',
      ],
    },
    {
      type: 'value',
      method: 'value:transformation',
      description: 'Transforms a value',
      agentId: 'ai-workflow-value-action-manager',
      icon: 'TodoIcon',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a {{service.method.split(":")[1]}} value helper is to transform and return the specified {{service.method.split(":")[0]}} for use later in the service following provided instructions.',
        `<Service>`,
        `<Goal>Provide the transformed value</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'useSearchAgent',
        'useInternetAgent',
        'useNotesAgent',
        ...defaultActions,
      ],
      tip: 'Provide the value to transform and the transformation to apply',
      validators: [
        'Instructions must include the value to transform or the source of the value',
        'Instructions must include the transformation to apply',
      ],
    },
    {
      type: 'data',
      method: 'node:fetch',
      description: 'Fetch a url using the nodeFetch tool which is a wrapper around the fetch API and supports all the same options plus it saves the response to a file',
      agentId: 'ai-workflow-data-action-manager',
      icon: 'GlobeIcon',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        `<Service>`,
        `<Goal>{{service?.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Your role is strictly scoped to fetching data. Anything additional is out of scope and strictly forbidden unless discussing the fetch request with the user</OutOfScope>',
        '<SuccessCriteria>You are successful when you use nodeFetch tool to fetch and save the data, then complete the session by saving the filePath returned from fetch using the saveSessionResult tool</SuccessCriteria>',
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'nodeFetch',
        ...defaultActions,
      ],
      tip: 'Provide the URL and method, plus any optional params like headers, body, etc.',
      validators: [
        'Instructions must include a valid URL',
        'Instructions must include a method of GET or POST',
        'The url must be accessible',
        'Unless localhost, the url must be secure',
      ],
    },
    {
      type: 'data',
      method: 'http:get',
      description: 'Load data from the item API used for retrieving internal resource data',
      agentId: 'ai-workflow-data-action-manager',
      icon: 'WebsiteIcon',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        `<Service>`,
        `<Goal>Get the requested resource data via it's resource path</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<SuccessCriteria>You are successful when you use the httpGET tool to load the resource data, followed by the saveSessionResult tool when finished</SuccessCriteria>',
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'httpGET',
        ...defaultActions,
      ],
      tip: 'Provide the resource path and describe the data you expect to get',
      validators: [
        'Instructions must include a valid item endpoint',
        'The endpoint must be a relative path in the format of /{collectionId}/{itemID} or /{collectionId}/{itemID}/{subCollection}',
      ],
    },
    {
      type: 'data',
      method: 'http:post',
      description: 'Post data to the item API used for performing operations on internal resource data',
      agentId: 'ai-workflow-data-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        `<Service>`,
        `<Goal>Perform the requested operation on a resource via it's resource path</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<SuccessCriteria>You are successful when you use the httpPOST tool to load the data, followed by the saveSessionResult tool when finished</SuccessCriteria>',
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'httpPOST',
        ...defaultActions,
      ],
      tip: 'Provide the resource path and optionally describe the action you want to perform',
      validators: [
        'Instructions must include a valid resource itemPath or endpoint',
        'The endpoint must be a relative path in the format of /{collectionId}/{itemID} or /{collectionId}/{itemID}/{operation}',
        "Examples: (/email-drafts/1234) or (/email-drafts/1234/send)",
        // 'The url must be accessible',
        // 'Unless localhost, the url must be secure',
        // 'Instructions must include or describe the data to post',
      ],
      icon: 'WebsiteIcon',
    },
    {
      type: 'data',
      method: 'web:search',
      description: 'Search the internet following provided instructions',
      agentId: 'ai-workflow-data-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        `<Service>`,
        "You are a helper for a multi-step service. Your role as a {{service.method.split(':')[1]}} helper is to search the internet and return the results to be used later in the service following provided instructions.",
        `<Goal>Get current information from the internet</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        "<Notes>",
        "To ensure the best results, use clear and specific search query.",
        "The search results will be returned in a structured format for easy processing.",
        "Use the Task Planner to plan the search for the best results in non-trivial or multi-step cases.",
        "</Notes>",
        '<SuccessCriteria>You are successful when you search the internet and then use the saveSessionResult tool when finished.</SuccessCriteria>',
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'useInternetAgent',
        'useTaskPlannerAgent',
        ...defaultActions,
      ],
      tip: 'Describe the internet search you want the app to perform',
      validators: [
        'Instructions must include the search query',
      ],
      icon: 'GlobeIcon',
    },
    {
      type: 'data',
      method: 'web:scrape',
      description: 'Crawl a website and scrape data from it',
      agentId: 'ai-workflow-data-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        "A helper for a multi-step service. Your role as a web {{service.method.split(':')[1]}} helper is to crawl the internet and scrape data from it to be used later in the service following provided instructions.",
        `<Service>`,
        `<Goal>{{service?.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'useInternetAgent',
        'useTaskPlannerAgent',
        ...defaultActions,
      ],
      tip: 'Provide the url and describe the data you want to scrape',
      validators: [
        'Instructions must include one or more urls to scrape',
        'Instructions must state whether links in scraped pages should be followed and up to what depth',
        'Instructions must state whether images should be downloaded',
        'Instructions must indicate whether http redirects should be followed',
      ],
      icon: 'GlobeIcon',
    },
    {
      type: 'dataset',
      method: 'collection:query',
      description: 'Provide data selected from database collection',
      agentId: 'ai-workflow-dataset-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        "A helper for a multi-step service. Your role as a Cloud Firestore {{service.method.split(':')[1]}} helper is to select data from the database collection and return it to be used later in the service following provided instructions.",
        `<Service>`,
        `<Goal>{{service?.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything beyond the explicit description and goal of this service</Example></OutOfScope>',
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'useFirestoreQuery',
        ...defaultActions,
      ],
      tip: "Indicate the collection to select records from and the selection criteria",
      validators: [
        'Instructions must include the collection ID',
        'Instructions must include the selection criteria',
      ],
      icon: 'DatabaseIcon',
    },
    {
      type: 'dataset',
      method: 'collection:items',
      description: 'Retrieve one or more items from a collection',
      agentId: 'ai-workflow-dataset-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        "A helper for a multi-step service. Your role as a Cloud Firestore {{service.method.split(':')[1]}} helper is to retrieve data from the database collection and return it to be used later in the service following provided instructions.",
        `<Service>`,
        `<Goal>Retrieve the specified items by path via the Cloud Firestore API using the httpGET tool</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything beyond the explicit description and goal of this service</Example></OutOfScope>',
        '<SuccessCriteria>You\'re successful when you efficiently perform the request then execute the saveSessionResult tool with the data to finish without performing any other actions</SuccessCriteria>',
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'httpGET',
        ...defaultActions,
      ],
      tip: 'Provide the itemIDs to retrieve',
      validators: [
        'Instructions must include the itemIDs in the format /{collection}/{ID}',
      ],
      icon: 'DatabaseIcon',
    },
    {
      type: 'dataset',
      method: 'record:update',
      description: 'Update a record in a collection',
      agentId: 'ai-workflow-dataset-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        "A helper for a multi-step service. Your role as a Cloud Firestore {{service.method.split(':')[1]}} helper is to update the specified record in the collection for use later in the service following provided instructions.",
        `<Service>`,
        `<Goal>Update the specified item</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything beyond the explicit description and goal of this service</Example></OutOfScope>',
        '<SuccessCriteria>You\'re successful when you update the specified field in the specified dataset using httpPUT then execute the saveSessionResult tool to finish without performing any other actions</SuccessCriteria>',
        `</Service>`,
      ].join('\n'),
      actionNames: [
        'httpPUT',
        ...defaultActions,
      ],
      tip: 'Provide instructions on the update(s) to perform',
      validators: [
        'Instructions must include the itemIDs or describe the workflow to get the itemIDs and update data',
        'Instructions must include the source of the new value',
      ],
      icon: 'DatabaseIcon',
      // components: [`[analyst](#path=)`],
    },
    {
      type: 'messenger',
      method: 'call:phone',
      description: 'Make phone call',
      agentId: 'ai-workflow-messenger-action-manager',
      useContext: true,
      updateContext: true,
      goal: 'Make a phone call to a recipient',
      modelPerformance: 'model:standard',
      contextTemplate: [
        '<Action>',
        `<Goal>{{service.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<SuccessCriteria>You are successful when you make the requested phone call to the recipient, perform the requested action(s), and then execute the saveSessionResult tool to finish, without performing any other actions.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'usePhoneCallAgent',
        'usePhoneCallTaskAgent',
        'useTaskPlannerAgent',
        ...defaultActions,
      ],
      tip: 'Describe the phone call you want to the app to make',
      validators: [
        'Must provide a phone number or instructions to get the phone number',
        'Must state whether the call is to be recorded',
        'Must state whether the call can be retried',
        'Must describe the purpose of the call or provide a message to be read to the recipient',
        'Must describe the expected outcome of the call',
        'Must state whether we should leave a message if the call is not answered',
      ],
      icon: 'PhoneCallIcon',
    },
    {
      type: 'messenger',
      method: 'send:sms',
      description: 'Send text message',
      agentId: 'ai-workflow-messenger-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      goal: 'Send a text message to a recipient',
      contextTemplate: [
        '<Action>',
        `<Goal>{{service.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<SuccessCriteria>You are successful when you send the SMS message to the recipient and then execute the saveSessionResult tool to finish, without performing any other actions.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'sendSMS',
        'useTaskPlannerAgent',
        ...defaultActions,
      ],
      tip: 'Describe the text message you want the app to send including the recipient phone number if not available in the context/data',
      validators: [
        'Must provide a phone number or instructions to get the phone number',
        'The phone number must be owned by the client or subscribed to the client\'s account',
        'Instructions must describe the message to be sent',
      ],
      icon: 'MessageOutlined',
    },
    {
      type: 'messenger',
      method: 'send:discord',
      description: 'Send message to Discord',
      agentId: 'ai-workflow-messenger-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        '<Action>',
        `<Goal>Post a message to Discord with useDiscordAgent</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything beyond the explicit description and goal of this service</Example></OutOfScope>',
        '<SuccessCriteria>You are successful when you send the message to Discord and then execute the saveSessionResult tool to finish, without performing any other actions.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useDiscordAgent',
        // 'useTaskPlannerAgent',
        ...defaultActions,
      ],
      tip: 'Describe the message you want to send including the webhookUrl to send the message to',
      validators: [
        'Instructions must describe the message to send',
        'Instructions must include a valid webhookUrl to send the message to',
      ],
      icon: 'DiscordIcon',
    },
    {
      type: 'messenger',
      method: 'send:telegram',
      description: 'Send message to Telegram',
      agentId: 'ai-workflow-messenger-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        '<Action>',
        `<Goal>{{service.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useTelegramAgent',
        'useTaskPlannerAgent',
        ...defaultActions,
      ],
      tip: 'Describe the message you want to send',
      validators: [
        'Instructions must describe the message to send',
        'Instructions must include the channel to send the message to',
        'The client must be authenticated to send messages to Telegram',
      ],
      icon: 'TelegramIcon',
    },
    {
      type: 'messenger',
      method: 'send:twitter',
      description: 'Send a tweet',
      agentId: 'ai-workflow-messenger-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      goal: 'Send a tweet to Twitter/X',
      contextTemplate: [
        '<Action>',
        `<Goal>{{service.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Method>{{service?.method}}</Method>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<SuccessCriteria>You are successful when you make the post to Twitter and then execute the saveSessionResult tool to finish, without performing any other actions.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useTwitterAgent',
        'useTaskPlannerAgent',
        ...defaultActions,
      ],
      tip: 'Describe the tweet you want to send',
      validators: [
        'Instructions must describe the tweet to send',
        'The client must be authenticated to send tweets',
      ],
      icon: 'TwitterIcon',
    },
    {
      type: 'reasoning',
      method: 'reasoning:basic',
      description: 'Fast reasoning and decision making',
      agentId: 'ai-workflow-reasoning-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:fastest',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a helper is to think deeply about the information provided and follow the instructions to achieve the goal. You specific role is in your ability to reason intelligently.',
        `<Service>`,
        `<Goal>{{service.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<SuccessCriteria>You\'re successful when you perform the task and save the result/continue/exit using the saveSessionResult, continue, or cancel tool. You must execute one of saveSessionResult, continue, or cancel as instructed to finish.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useSearchAgent',
        'useInternetAgent',
        'useNotesAgent',
        'useEmailDraftAgent',
        'useTaskPlannerAgent',
        'useRemindersAgent',
        'useCalendarAgent',
        'usePhoneCallAgent',
        'useVoiceChatAgent',
        ...defaultActions,
        'continue',
        'cancel',
      ],
      tip: 'Describe the reasoning you want to perform. For example, \'Review the list and continue with items under $100, ignore the rest\'',
      validators: [
        'Instructions must describe the reasoning to perform',
        'Instructions must state the expected outcome of the reasoning',
        'The reasoning must be within the scope of the app',
        'The reasoning must be verified as logical and ethical',
      ],
      icon: 'CPUIcon',
    },
    {
      type: 'reasoning',
      method: 'reasoning:medium',
      description: 'Standard reasoning and decision making',
      agentId: 'ai-workflow-reasoning-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a helper is to think deeply about the information provided and follow the instructions to achieve the goal. You specific role is in your ability to reason intelligently.',
        `<Service>`,
        `<Goal>{{service.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<SuccessCriteria>You\'re successful when you are thoughtful about the provided input, use detailed requests when working with tools/agents, and finally execute the saveSessionResult, continue, or cancel tool based on provided instructions.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useSearchAgent',
        'useInternetAgent',
        'useNotesAgent',
        'useEmailDraftAgent',
        'useTaskPlannerAgent',
        'useRemindersAgent',
        'useCalendarAgent',
        'usePhoneCallAgent',
        'useVoiceChatAgent',
        ...defaultActions,
        'continue',
        'cancel',
      ],
      tip: 'Describe the reasoning you want to perform. For example, \'Review the list and continue with items under $100, ignore the rest\'',
      validators: [
        'Instructions must describe the reasoning to perform',
        'Instructions must state the expected outcome of the reasoning',
        'The reasoning must be within the scope of the app',
        'The reasoning must be verified as logical and ethical',
      ],
      icon: 'CPUIcon',
    },
    {
      type: 'reasoning',
      method: 'reasoning:expert',
      description: 'Expert reasoning and decision making',
      agentId: 'ai-workflow-reasoning-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:pro',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a helper is to think deeply about the information provided and follow the instructions to achieve the goal. You specific role is in your ability to reason intelligently.',
        `<Service>`,
        `<Goal>{{service.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<SuccessCriteria>You\'re successful when you are thoughtful about the provided input, use detailed requests when working with tools/agents, and finally execute the saveSessionResult, continue, or cancel tool to finish.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useSearchAgent',
        'useInternetAgent',
        'useNotesAgent',
        'useEmailDraftAgent',
        'useTaskPlannerAgent',
        'useRemindersAgent',
        'useCalendarAgent',
        'usePhoneCallAgent',
        'useVoiceChatAgent',
        ...defaultActions,
        'continue',
        'cancel',
      ],
      tip: 'Describe the reasoning you want to perform. For example, \'Review the list and continue with items under $100, ignore the rest\'',
      validators: [
        'Instructions must describe the reasoning to perform',
        'Instructions must state the expected outcome of the reasoning',
        'The reasoning must be within the scope of the app',
        'The reasoning must be verified as logical and ethical',
      ],
      icon: 'CPUIcon',
    },
    {
      type: 'persistence',
      method: 'records:insert',
      description: 'Add records to a collection',
      agentId: 'ai-workflow-persistence-action-manager',
      useContext: true,
      updateContext: true,
      icon: 'TbDatabasePlus',
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a helper is follow provided instructions to complete the task for this service.',
        `<Service>`,
        `<Goal>{{service?.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<Task>Use httpPOST to insert data to the specified collection.</Task>',
        '<Notes>',
        'A collectionId should be provided. If one is not available in the context, throw an error using the tool.',
        'Endpoint: /collections/[collectionId]/insert',
        'Body: The provided list data ({data}) or file path to the data ({filePath}) as JSON string',
        'Example valid request:',
        'INPUT: collectionId: user-messages, data: [{"message": "Hello world!"}]',
        'httpPOST TOOL:\nendpoint: /collections/user-messages/insert\nbody: { "data": [{"message": "Hello world!"}] }',
        '</Notes>',
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<SuccessCriteria>You\'re successful when the data is successfully inserted to the collection using httpPOST and then saveSessionResult to finish.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      instructions: 'Add data to the specified collection',
      actionNames: [
        'httpPOST',
        ...defaultActions,
      ],
      tip: 'Provide the collectionID and data to insert',
      validators: [
        'Instructions must include the collection ID',
      ],
    },
    {
      type: 'persistence',
      method: 'to:json',
      description: 'Save data as JSON',
      agentId: 'ai-workflow-persistence-action-manager',
      useContext: true,
      updateContext: true,
      icon: 'JsonIcon',
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a helper is follow provided instructions for the service.',
        `<Service>`,
        `<Goal>{{service?.goal}}</Goal>`,
        `<Service>{{service?.description}}</Service>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<SuccessCriteria>You\'re successful when the persistence request is completed.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      instructions: 'Save data to json',
      actionNames: [
        'useFileSaveAsAgent',
        'useInternetAgent',
        'useSearchAgent',
        ...defaultActions,
      ],
      validators: [
        'Instructions must include the data to save or an input path to the data must be selected',
      ],
    },
    {
      type: 'persistence',
      method: 'to:pdf',
      description: 'Save data to PDF',
      agentId: 'ai-workflow-persistence-action-manager',
      useContext: true,
      updateContext: true,
      // inputPaths: ["/last"],
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a helper is follow provided instructions for the service.',
        `<Service>`,
        `<Goal>{{service?.goal}}</Goal>`,
        `<Service>{{service?.description}}</Service>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<SuccessCriteria>You\'re successful when the persistence request is completed.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useFileSaveAsAgent',
        'useInternetAgent',
        'useSearchAgent',
        ...defaultActions,
      ],
      instructions: 'Save data to PDF',

      validators: [
        'Instructions must include the data to save or an input path to the data must be selected',
        'Styling must be provided for the PDF',
      ],
      icon: 'TbFileTypePdf',
    },
    {
      type: 'persistence',
      method: 'to:webpage',
      description: 'Save as html webpage',
      agentId: 'ai-workflow-persistence-action-manager',
      useContext: true,
      updateContext: true,
      instructions: 'Save data to html page',
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a helper is follow provided instructions for the service.',
        `<Service>`,
        `<Goal>{{service?.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<SuccessCriteria>You\'re successful when the persistence request is completed.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useFileSaveAsAgent',
        'useInternetAgent',
        'useSearchAgent',
        ...defaultActions,
      ],
      validators: [
        'Instructions must include the data to save or an input path to the data must be selected',
        'Styling must be provided or described for the webpage',
        'Styling can be provided as a link to a webpage whose style will be replicated with input data',
      ],
      icon: 'TbFileTypeHtml',
    },
    {
      type: 'persistence',
      method: 'to:file',
      description: 'Save As arbitrary file type',
      agentId: 'ai-workflow-persistence-action-manager',
      useContext: true,
      updateContext: true,
      instructions: 'Save data as type indicated',
      modelPerformance: 'model:standard',
      contextTemplate: [
        'You are a helper for a multi-step service. Your role as a helper is follow provided instructions for the service.',
        `<Service>`,
        `<Goal>{{service?.goal}}</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<SuccessCriteria>You\'re successful when the persistence request is completed.</SuccessCriteria>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useFileSaveAsAgent',
        'useInternetAgent',
        'useSearchAgent',
        ...defaultActions,
      ],
      validators: [
        'Instructions must include the data to save or an input path to the data must be selected',
        'Instructions must include the file type to save as',
        'Supported types are: ' + Object.entries(contentTypes).filter(([mimeType, status]) => status !== "unsupported").map(([mimeType, status]) => mimeType).join(', '),
      ],
      icon: 'TbFileAi',
    },
    {
      type: 'task',
      method: 'task:deep-research',
      description: 'Performs deep research task',
      agentId: 'ai-workflow-task-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        // "You are a helper for a multi-step service. Your role as a helper is to complete tasks using a provided agent.",
        `<Service>`,
        `<Goal>Follow the steps to successfully perform the specified deep research task</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '<Steps>',
        'You\'re successful when you perform the following steps:',
        '1. Ask the taskPlannerAgent to develop a plan that includes all the websites and searches needed to compile necessary facts.',
        '2. Execute useTaskStepWorker to perform the steps in the plan.',
        '3. Carefully review all of the information for deep understanding.',
        '4. Generate a report detailing your findings, including any relevant data, links, images, or information.',
        '5. Execute saveSessionResult to save the report and finish.',
        '</Steps>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'useTaskPlannerAgent',
        'useTaskStepWorker',
        'useInternetAgent',
        'useSearchAgent',
        ...defaultActions,
      ],
      tip: 'Describe the research task you want to perform',
      validators: [
        'Instructions must describe the research task',
        'Instructions must include the expected outcome of the research',
        'The goal of the research must be clearly stated',
        'The research must be within the scope of the app',
        'The research must be logical and ethical',
      ],
      icon: 'TodoIcon',
    },
    {
      type: 'task',
      method: 'app:runner',
      description: 'This service lets you run a specified app and use it\'s output',
      agentId: 'ai-workflow-task-action-manager',
      useContext: true,
      updateContext: true,
      modelPerformance: 'model:standard',
      contextTemplate: [
        "You are a helper for a multi-step service. Your role as a app runner helper is to run a specific external app as a step in this process.",
        `<Service>`,
        `<Goal>Successfully run the specified app</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Context>{{(context && service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Anything not specifically instructed</OutOfScope>',
        '</Action>',
      ]
      .join('\n'),
      actionNames: [
        'nodeFetch',
        ...defaultActions,
      ],
      tip: 'Describe the research task you want to perform',
      validators: [
        'Instructions must describe the app to run.',
        'Instructions must include the expected outcome of the app\'s execution.',
        'Known app dependencies must be accounted for.',
      ],
      icon: 'TodoIcon',
    },
    // {
    //   type: 'composio',
    //   label: 'integrations',
    //   description: 'Integrate hundreds of your favorite apps and services with Composio',
    //   icon: 'GlobeIcon',
    //   children: [
    //     ...(integrations || []).map((integration) => {
    //       const label = (integration.name ?? integration.appName).replace(/[^a-zA-Z0-9]+/g, " ");
    //       return {
    //         type: 'integration',
    //         method: `use:${integration.name ?? integration.appName}`,
    //         label,
    //         description: "Utilize and manage provided third-party integration", // integration.description,
    //         agentId: 'ai-composio-action-manager',
    //         icon: integration.icon || 'GlobeIcon',
    //         logo: integration.logo,
    //         useContext: true,
    //         updateContext: true,
    //         modelPerformance: 'model:standard',
    //         authOptions: integration
    //           ?.["auth_schemes"]
    //           ?.map?.((scheme) =>
    //             scheme?.mode && ({method: scheme?.mode, provider: "composio"}))
    //           .filter(Boolean),
    //         contextTemplate: [
    //           `<Action>`,
    //           `<Goal>Perform the request using {{service.label}} integration</Goal>`,
    //           `<Description>{{service?.description}}</Description>`,
    //           `<Type>{{service?.type}}</Type>`,
    //           `<Method>{{service?.method}}</Method>`,
    //           `<Integration id="${integration.appId}">${integration.description}</Integration>`,
    //           `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
    //           '<OutOfScope>Your role is strictly scoped to using the integration as requested. Anything additional is out of scope and strictly forbidden unless discussing the request with the user</OutOfScope>',
    //           '<SuccessCriteria>You are successful when you execute useExternalIntegrationAgent to perform requests on ${label} and complete the request</SuccessCriteria>',
    //           `</Action>`,
    //         ].join('\n'),
    //         actionNames: [
    //           "useIntegrationAgent",
    //           ...defaultActions,
    //         ],
    //       }
    //     })
    //   ]
    // },
  ];
  React.useEffect(() => {
    h &&
    dispatch(collectionActions.fetch("workflow-helpers", {
      path: [h, helpersId].join("/"),
    }));
  }, [h, helpersId]);

  React.useEffect(() => {
    dispatch(aiActions.setActiveApp([ctx.basePath, props.workflowId].join("/"), ctx.collectionId));
    return () => {
      dispatch(aiActions.clearActiveApp(ctx.collectionId));
    };
  }, [ctx.collectionId, props.workflowId]);

  const onSetActiveAppService = React.useCallback((stepIndex) => {
    dispatch(aiActions.setActiveActionIndex(stepIndex, ctx.collectionId));
  }, [dispatch]);

  const onClearActiveAppService = React.useCallback((stepIndex) => {
    dispatch(aiActions.clearActiveActionIndex(stepIndex, ctx.collectionId));
  }, [dispatch]);

  if (props.workflowId && ctx.objectId && !workflow) {
    return <Card
      title={<div className="font-lg"><Tag className="rounded">404</Tag> Workflow not found</div>}
      className="card-simple card-rounded card-inline card-no-separator"
      bordered={false}
      style={{width: '100%', maxWidth: 600, margin: '0 auto'}}
    />;
  }

  if (!helpers) {
    return <Loading />;
  }

  return <WorkflowsContext.Provider
    value={{
      workflow: workflow,
      workflowId: props.workflowId,
      workflowPath: [ctx.basePath, props.workflowId].join('/'),
      stepHelpers: helpers,
    }}
  >
    <List
      header={<WorkflowMain />}
      dataSource={workflow?.steps}
      renderItem={(service, index) => {
        return <Action
          stepIndex={index}
          action={service}
          activeServiceView={activeServiceView}
          onServiceViewChange={setActiveServiceView}
          onSelect={onSetActiveAppService}
          onClearSelect={onClearActiveAppService}
          // component={Action}
        />;
      }}
    />
  </WorkflowsContext.Provider>;
}

export default WorkflowEditor;
